import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { LanguageService } from '@fcom/ui-translate';
import { NativeBridgeService } from '@fcom/core';

@Component({
  selector: 'fin-booking-entry-route',
  template: `
    <div class="booking-entry-route nordic-blue-50-bg ps-medium-y" *ngIf="shouldRender">
      <fin-booking-widget></fin-booking-widget>
    </div>
  `,
  styleUrls: ['booking-entry-route.component.scss'],
  standalone: false,
})
export class BookingEntryRouteComponent implements OnInit {
  shouldRender: boolean;

  constructor(
    private nativeBridge: NativeBridgeService,
    private languageService: LanguageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.shouldRender = this.nativeBridge.isInsideNativeWebView;

    // Redirect non-mobile-app requests to front page
    if (!this.nativeBridge.isInsideNativeWebView) {
      this.router.navigate([`/${this.languageService.langValue}`], {
        replaceUrl: true,
        queryParamsHandling: 'preserve',
      });
      return;
    }
  }
}
